var exports = {
  "PT": "Markup.module__markup___bF83M1",
  "z3": "Markup.module__bio___bF83M1",
  "Z_": "Markup.module__mutedSpoilerContext___bF83M1",
  "nf": "Markup.module__link___bF83M1",
  "mG": "Markup.module__inline___bF83M1",
  "tZ": "Markup.module__inlineFormat___bF83M1",
  "Hy": "Markup.module__codeContainer___bF83M1",
  "h": "Markup.module__blockquoteContainer___bF83M1",
  "xE": "Markup.module__alert___bF83M1",
  "CZ": "Markup.module__tableContainer___bF83M1",
  "js": "Markup.module__latexCodeBlock___bF83M1",
  "lB": "Markup.module__codeActions___bF83M1",
  "vo": "Markup.module__codeActionsVisible___bF83M1",
  "r": "Markup.module__blockquoteDivider___bF83M1",
  "rs": "Markup.module__blockquoteContent___bF83M1",
  "em": "Markup.module__blockquoteEmptyContent___bF83M1",
  "tp": "Markup.module__table___bF83M1",
  "qd": "Markup.module__tableHeader___bF83M1",
  "xR": "Markup.module__tableCell___bF83M1",
  "Vl": "Markup.module__alignLeft___bF83M1",
  "Hu": "Markup.module__alignCenter___bF83M1",
  "Wk": "Markup.module__alignRight___bF83M1",
  "Qd": "Markup.module__alertIcon___bF83M1",
  "Ro": "Markup.module__alertTitle___bF83M1",
  "S9": "Markup.module__alertContent___bF83M1",
  "FU": "Markup.module__alertNote___bF83M1",
  "ap": "Markup.module__alertTip___bF83M1",
  "nL": "Markup.module__alertImportant___bF83M1",
  "vc": "Markup.module__alertWarning___bF83M1",
  "SN": "Markup.module__alertCaution___bF83M1",
  "lE": "Markup.module__mention___bF83M1",
  "bG": "Markup.module__interactive___bF83M1",
  "vE": "Markup.module__timestamp___bF83M1",
  "CU": "Markup.module__spoilerWrapper___bF83M1",
  "N5": "Markup.module__blockSpoilerWrapper___bF83M1",
  "p6": "Markup.module__spoiler___bF83M1",
  "mC": "Markup.module__blockSpoiler___bF83M1",
  "ur": "Markup.module__spoilerContent___bF83M1",
  "yI": "Markup.module__latexContent___bF83M1",
  "Y4": "Markup.module__hljs___bF83M1",
  "HQ": "Markup.module__ansiCode___bF83M1",
  "bi": "Markup.module__ansi-code-blink___bF83M1",
  "So": "Markup.module__error___bF83M1",
};

module.exports = exports;
